// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-datepicker__input-container {
	input {
		background: transparent;
	}
}

.header_aR2Gy {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	width: 100%;
	justify-content: space-between;
	overflow-x: visible;
	background: var(--white-color);
	padding: 10px 10px 10px 70px;

	&::-webkit-scrollbar {
		display: none;
	}

	.top_E1vxr {
		display: inline-flex;
		align-items: center;
		gap: 6px;

		.buttons_NEm4D {
			display: inline-flex;
			align-items: center;
			gap: 4px;

			svg {
				width: 20px;
				min-width: 20px;
				min-height: 20px;
			}
		}

		.expand_POsJO {
			width: 40px;
			height: 40px;
			display: inline-flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			border-radius: 4px;

			&:hover {
				background: var(--border-color);
			}

			svg {
				min-width: 25px;
				min-height: 25px;
				width: 25px;
			}
		}

		.toDay_YD4Zb {
			background: var(--_16c0982e-background);
			border: 1px solid var(--border-color) !important;
			padding: 6px 12px;
			border-radius: 4px;
			border: none;
			outline: none;
			width: 77px;
			min-width: 77px;
			cursor: pointer;
			font-family: inherit;
			width: max-content;
			font-size: 17px;
		}
		.actualToday_iZnpY {
			background: var(--_10a37f-background);
			border: none !important;
			outline: none;
			cursor: pointer;
			font-family: inherit;
			color: var(--white-color);
			width: 77px;
			min-width: 77px;
			border: 1px solid var(--_10a37f-background);
			padding: 6px 12px;
			width: max-content;
			border-radius: 4px;
			font-size: 17px;
		}



		.buttonsNavs_CbHXL {
			display: inline-flex;
			align-items: center;
			gap: 5px;

			button {
				display: inline-flex;
				justify-content: center;
				align-items: center;
				width: 40px;
				height: 40px;
				border-radius: 4px;
				border: 1px solid var(--border-color);
				background: var(--_10a37f-background);
				color: var(--_16c098-background);
				cursor: pointer;
				svg {
					min-width: 26px;
					min-height: 26px;
					color: var(--_16c0982e-background);
					fill: transparent;
					width: 26px;
				}
				&:hover {
					background: var(--_16c098-background);
					color: var(--_10a37f-background);
				}
			}
		}
	}

	[class^='react-datepicker-wrapper'] {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		padding: 10px 10px;
		height: 40px;
		border-radius: 4px;
		border: 1px solid var(--border-color);

		input {
			width: 110px;
			outline: none;
		}
	}

	.buttonsCalendars_k2ItT {
		display: inline-flex;
		align-items: center;
		gap: 4px;

		button {
			background: var(--_16c0982e-background);
			border: none;
			outline: none;
			cursor: pointer;
			font-family: inherit;
			height: 40px;
			border: 1px solid var(--border-color);
			padding: 6px 12px;
			width: max-content;
			border-radius: 4px;
			font-size: 17px;

			&.active_Hrvyf {
				border-color: var(--_10a37f-background);
				color: var(--_10a37f-background);
			}

			&:hover {
				border-color: var(--_16c098-background);
				color: var(--_16c098-background);
			}

			svg {
				min-width: 22px;
				width: 22px;
			}
		}
	}
}

.container_ozqP_ {
	position: fixed;
	width: 100vw;
	height: calc(100vh);
	left: 0px;
	background: var(--f5-background);
	color: var(--text-color-secondary);

	.app_hsNVI {
		padding-left: 70px;
		background: var(--white-color);
		position: relative;
		z-index: 5000;
		display: flex;
		align-items: flex-start;
		gap: 2px;
		height: calc(100vh - 105px);

		.menu_WYe8x {
			height: 100%;
			min-width: 240px;
			width: 240px;
			padding: 16px;
			background: var(--white-color);

			&.expand_POsJO {
				display: none;
				min-width: 0px;
				width: 0px;
			}
		}
	}
}
.firstTh_vyCaw {
	border-bottom: none !important;
}
.hourZoneWrapper_HhhGb {
	position: relative;
	background: var(--f5-background) !important;
	border-top: none !important;
}
.weekHourContent_DtKgu {
	position: relative !important;
}
.hourContent_K6fvJ {
	padding-left: 10px;
	position: relative !important;
	display: flex;
	border-top: none !important;
	flex-direction: row;
}
.eventPopup_FIFiO {
	position: absolute;
	top: 97px;
	border-radius: 8px;
	z-index: 700000;
}
.selectedHourContent_Rp_zp {
	display: flex;
	width: 100%;
	margin-right: 2px;
	background: var(--_16c0982e-background);
	padding: 2px 5px;
	flex-direction: column;
	border-radius: 4px;
	justify-content: flex-start;
	color: var(--white-color);
	align-items: flex-start;
	font-size: 12px;
	font-weight: 500;
	height: 100%;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
	position: relative;
}
.monthTr_JY25K {
	width: 100%;
}
.monthTd_JpEoz {
	position: relative;
}
.hourZoneInner_ilaiX {
	position: absolute;
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
	bottom: -1px;
	width: calc(100% - 10px);
	right: 10px;
	z-index: 100000;
	background: var(--f5-background);
	color: var(--_10a37f-background);
	padding: 2px 8px;
	font-size: 11px;
	font-weight: 500;
}
.dayMonthContainer_tunKk {
	position: relative;
}
.dayMonthInnerContainerWrapper_e3YH4 {
	position: absolute;
	padding-left: 5px;
	left: -1px;
	top: 0;
	padding-top: 5px;
	width: calc(100% + 1px);
	background: var(--f5-background);
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	flex-direction: column;
}
.dayMonthInnerContainerWrapperWeek_u0JjC {
	position: absolute;
	padding-left: 5px;
	left: -1px;
	top: 0;
	padding-top: 5px;
	width: calc(100% + 1px);
	background: var(--f5-background);
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: column;
}
.dayMonthInnerContainer_anzRz {
	display: flex;
	padding-left: 5px;
	align-items: center;
	justify-content: flex-start;
	flex-direction: column;
}
.dayText_yyjed {
	color: var(--_16c098-background);
	font-weight: 500;
	font-size: 12px;
}
.dayCircle_FP45k {
	width: 45px;
	height: 45px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 8px;
	font-size: 26px;
	padding-right: 1px;
	font-weight: 500;
	background-color: var(--_16c09821-background);
	color: var(--white-color);
}
.selectedDayCircle_UZVGR {
	width: 45px;
	height: 45px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 8px;
	font-size: 26px;
	padding-right: 1px;
	font-weight: 500;
	background-color: var(--_10a37f-background);
	color: var(--white-color);
}
.hourContainer_CgGrr {
	position: absolute;
	top: -9px;
	right: 10px;
	background: var(--f5-background);
	width: calc(100% - 10px);
	padding-right: 5px;
}
.belowGMTTd_A9_Do {
	background: var(--f5-background);
	border-left: none !important;
	max-width: 70px !important;
}

.tableCalendar_OMmQQ {
	border-radius: 8px;
	z-index: 5000;
	width: 100%;
	background-color: var(--f5-background);
	height: calc(100vh - 112px);
	overflow: scroll;
	table {
		width: 100%;

		th {
			text-align: left;
			min-height: 100px;
		}

		td {
			border: 1px solid var(--border-color);
			text-align: center;
			background-color: var(--white-color);

			&.active_Hrvyf {
				background: var(--_16c09821-background);
				border-color: var(--_16c098-color);
				color: var(--_16c098-color);
				cursor: pointer;

				&:hover {
					background: var(--e6fff9-background);
					border-color: var(--_16c09821-background);
					color: var(--_16c09821-background);
				}
			}
		}
	}
}
.calendarDay_xojCH {
	min-width: 750px;
	th,
	td {
		width: 7%;
		min-height: 40px;
		height: 40px;
	}

	th:nth-child(1),
	td:nth-child(1) {
		position: relative;
		min-width: 70px;
		width: 70px;
		background: var(--f5-background);
		color: var(--_10a37f-background);
		border-color: var(--border-color);
		border-left: none !important;
		border-right: none !important;
		padding: 2px 5px;
		font-size: 11px;
		font-weight: 500;
		text-align: right;
	}

	th {
		background: var(--_16c0982e-background);
		color: var(--_10a37f-background);
		border-color: var(--_16c0982e-background);
		padding: 2px 9px;
		font-size: 15px;
		font-weight: 600;
	}

	th:nth-child(1) {
		background: var(--f5-background);
	}

	th:nth-child(2),
	td:nth-child(2) {
		width: 100%;
	}
}
.calendarWeek_AdmTw {
	min-width: 750px;
	th,
	td {
		width: 11vw !important;
		min-height: 40px;
		height: 40px;
	}
	tbody {
		background-color: var(--f5-background);
	}
	th:nth-child(1),
	td:nth-child(1) {
		position: relative;
		min-width: 70px;
		width: 70px !important;
		background: var(--f5-background);
		color: var(--_10a37f-background);
		border-color: var(--border-color);
		border-left: none !important;
		border-right: none !important;
		padding: 2px 5px;
		font-size: 11px;
		font-weight: 500;
		text-align: right;
	}

	th {
		background: var(--_16c0982e-background);
		color: var(--_10a37f-background);
		border-color: var(--_16c0982e-background);
		padding: 2px 9px;
		font-size: 15px;
		font-weight: 600;
	}

	th:nth-child(1) {
		background: var(--f5-background);
	}
}

.events_Zye9X {
	background: var(--f5-background);
	display: inline-flex;
	flex-direction: column;
	gap: 2px;
	width: 100%;
	padding: 10px;

	.item_x8H4v {
		display: flex;
		flex-direction: column;
		gap: 2px;
		border: 1px solid var(--border-color);
		padding: 6px;
	}

	strong {
		font-size: 10px;
		text-transform: uppercase;
		line-height: 2px;
		margin-top: 7px;
	}


}

.calendarMonth_ZuSkR {
	min-width: 750px;
	th,
	td {
		width: calc(100% / 7);
	}

	th {
		text-align: center;
		border-bottom: none;
		color: var(--_10a37f-background);
		border-color: var(--_16c0982e-background);
		font-size: 11px;
		padding-top: 2px;
	}

	td {
		border-top: none;
		height: calc((100vh / 5) - 26px);

		.day_MdvaO {
			display: inline-flex;
			flex-direction: column;
			position: relative;
			align-items: center;
			justify-content: flex-start;
			height: 100%;
			max-height: 175px;
			width: 100%;

			b {
				font-size: 14px;
				font-weight: 800;
			}

			ul {
				margin-top: 4px;
				display: inline-flex;
				flex-direction: column;

				li {
					display: block;
					display: inline-flex;
					flex-direction: column;
					align-items: center;
					gap: 4px;

					.date_Hji3n {
						display: inline-flex;
						align-items: center;
						gap: 4px;

						.dot_TtuBQ {
							min-width: 8px;
							min-height: 8px;
							border-radius: 50%;
							background: var(--_16c0982e-background);

							&.active_Hrvyf {
								background: var(--_10a37f-background);
							}
						}

						span {
							font-size: 11px;
							font-weight: 500;
						}
					}

					.info_PkleC {
						width: 80px;
						font-size: 10px;
						font-weight: 600;
						background: var(--white-color);
						border-radius: 6px;
						padding: 2px 4px;
						text-wrap: nowrap;
						cursor: pointer;
						&::-webkit-scrollbar {
							display: none;
						}
						&:hover {
							background: var(--f5-background);
						}

						span {
							font-size: 10px;
							font-weight: 400;
						}

						b {
							width: 100px;
							font-size: 14px;
							font-weight: 600;
						}
					}
				}
			}
		}
	}
	thead tr {
		border: 1px solid var(--border-color);
	}
	thead tr th {
		background: var(--white-color);
		text-align: center;
		border-right: 1px solid var(--border-color);
	}
}
.notScrollableTableCalendar_MVJI0 {
	overflow: hidden !important;
}
.calendarDayHeader_FnAub {
	min-height: 100px !important;
}

.monthDayLi_PrdJ4 {
	padding: 3px;
	border-radius: 2px;
	display: flex;
	width: 100%;
	max-width: 150px;
	position: relative;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	justify-content: flex-start;
	align-items: flex-start;
	&:hover {
		background: var(--border-color);
	}
	div {
		span {
			max-width: 130px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
}
.monthDayContainer_ZhOgI {
	margin: 2px;
	border-radius: 50%;
	font-size: 10px;
	width: 25px;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 25px;
	font-weight: 400 !important;
	background-color: var(--_16c09821-background);
	color: var(--white-color);
}
.selectedMonthDayContainer_N5Xqg {
	margin: 2px;
	border-radius: 50%;
	font-size: 10px;
	width: 25px;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 25px;
	font-weight: 400 !important;
	background-color: var(--_10a37f-background);
	color: var(--white-color);
}
.scheduleWrapper_H_CpN {
	min-width: 750px;
	display: flex;
	align-items: flex-start;
	flex-direction: column;
	justify-content: flex-start;
	width: 100%;
}

.scheduleEventsContainer_cidOt {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	flex-direction: column;
	width: 100%;
}
.calendarContainer_ayZKL {
	width: 100%;
	padding: 20px;
	background-color: var(--f5-background);
}




.dayHeader_wzd5d {
	flex: 1 1;
	text-align: center;
	padding: 10px;
	font-weight: bold;
	background-color: var(--_16c0982e-background);
	color: var(--_10a37f-background);
	border-radius: 5px;
	margin-right: 2px;
	box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.2);
}




.dayCell_QuY4q {
	flex: 1 1;
	min-height: 100px;
	padding: 10px;
	-webkit-user-select: none;
	        user-select: none;
	margin-right: 2px;
	border-radius: 4px;
	position: relative;
	background-color: var(--_16c098-color);
	box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.2);
}



.eventText_W4huq {
	background-color: var(--_16c09821-background);
	padding: 5px;
	border-radius: 5px;
	color: var(--_10a37f-background);
	font-size: 12px;
	text-align: center;
}

.calendarMonthWrapper_ij94I {
	display: flex;
	flex-direction: column;
	width: 100%;
}


.timeline_y22OX {
	display: flex;
	width: 100%;
	padding: 10px 20px 10px 70px;
	height: 100%;
	flex-direction: column;
	min-width: 990px;
	background-color: var(--f5-background);
}


.dayContainer_SYnP0 {
	display: flex;
	height: 35px;
	align-items: center;
	justify-content: flex-start;

	border: 1px solid var(--border-color);
	border-radius: 4px;
	margin-bottom: 15px;
	position: relative;
}


.navArrow_uicrM {
	background-color: var(--_16c09821-background);
	color: var(--white-color);
	border: none;
	height: 100%;
	font-size: 11px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	border-radius: 3px 0px 0px 3px;
	cursor: pointer;
	transition:
		background 0.2s ease-in-out,
		transform 0.1s ease-in-out;
	&:hover {
		background: var(--e6fff9-background);
		transform: scale(1.05);
	}

	&:active {
		background: var(--_16c09821-background);
		transform: scale(0.95);
	}
}

.navArrowRight_jq2Ub {
	background-color: var(--_16c09821-background);
	color: var(--white-color);
	border: none;
	height: 100%;
	font-size: 11px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	border-radius: 0px 3px 3px 0px;
	cursor: pointer;
	transition:
		background 0.2s ease-in-out,
		transform 0.1s ease-in-out;
	&:hover {
		background: var(--e6fff9-background);
		transform: scale(1.05);
	}

	&:active {
		background: var(--_16c09821-background);
		transform: scale(0.95);
	}
}

.timelineDays_pPL6q {
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
}

.timelineDay_lEWhH {
	text-align: start;
	padding: 0px 5px;
	height: 100%;
	display: flex;
	align-items: center;
	font-size: 14px;
	font-weight: 600;
	color: var(--_16c09821-background);
}

.eventsContainer_owEfo {
	display: flex;
	width: 100%;
	position: relative;
	background-color: var(--white-color);
	height: 100%;
}


.eventsForDay_Qa51T {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;
	overflow-x: show;
	gap: 3px;
	overflow-y: auto;
}


.timelineEventCard_QLqcG {
	display: flex;
	flex-direction: row;
	width: 100%;
	gap: 3px;
	height: 50px;
	min-height: 50px;
	padding: 0px 5px;
	align-items: center;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	align-items: center;
	justify-content: flex-start;
	border-radius: 3px;
	&:hover {
		background-color: var(--_16c0982e-background);
		.eventDesc_X3itk {
			color: var(--white-color);
		}
	}
}
.eventColorDiv_emoMh {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	height: 37px;
	min-width: 8px;
	border-radius: 15px;
	width: 8px;
}
.eventRightContainer_Xah68 {
	display: flex;
	align-items: center;
	width: 100%;
	justify-content: flex-start;
	gap: 3px;
	flex-direction: row;
}
.eventUserImage_n_6GZ {
	display: flex;
	width: 27px;
	max-width: 27px;
	min-width: 27px;
	height: 27px;
	max-height: 27px;
	min-height: 27px;
	align-items: center;
	justify-content: center;
	font-size: 15px;
	font-weight: bold;
	border-radius: 50px;
	color: var(--white-color);
	background-color: var(--_16c098-color);
}
.eventData_ty9NC {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	height: 100%;
	flex-direction: column;
}
.eventTitle_aNYm4 {
	color: var(--_3c3a3a-color);
	font-size: 13px;
	white-space: nowrap;
	overflow: hidden;
	font-weight: 600;
	text-overflow: ellipsis;
	line-height: 1.2;
}
.eventDesc_X3itk {
	color: var(--text-color-secondary);
	font-size: 11px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 1;
}

.eventTitle_aNYm4,
.eventDesc_X3itk {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	transition: max-width 0.3s ease-in-out;
}

.timelineEventCard_QLqcG:hover .eventTitle_aNYm4,
.timelineEventCard_QLqcG:hover .eventDesc_X3itk {
	max-width: none !important; 
}

.showMoreButton_Y7Bnl {
	color: var(--_16c0982e-background);
	cursor: pointer;
	font-size: 12px;
	margin-left: -2px;
	font-weight: 600;
	text-align: center;
	width: 100%;
	&:hover {
		color: var(--_16c098-color);
	}
}

.hoursWrapper_yX3VG {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	flex-direction: column;
	border-radius: 5px;
	border: 1px solid var(--_16c0982e-background);
	background-color: var(--white-color);
}

.hourItem_kdVHQ {
	font-size: 11px;
	position: relative;
	display: flex;
	margin-left: -22px;
	align-items: flex-start;
	color: var(--_10a37f-background);
	justify-content: flex-start;
	font-weight: 500;
	width: 100%;
	border-bottom: 1px solid var(--border-color);
}
.hourText_QJM5_ {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	position: absolute;
	height: 100%;
	left: -50px;
	top: -8px;
}

.eventListContainer_WlTaS {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/WatchCalendar/CalendarsStyles.module.css"],"names":[],"mappings":"AAAA;CACC;EACC,uBAAuB;CACxB;AACD;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,WAAW;CACX,8BAA8B;CAC9B,mBAAmB;CACnB,8BAA8B;CAC9B,4BAA4B;;CAE5B;EACC,aAAa;CACd;;CAEA;EACC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;;EAER;GACC,oBAAoB;GACpB,mBAAmB;GACnB,QAAQ;;GAER;IACC,WAAW;IACX,eAAe;IACf,gBAAgB;GACjB;EACD;;EAEA;GACC,WAAW;GACX,YAAY;GACZ,oBAAoB;GACpB,sBAAsB;GACtB,uBAAuB;GACvB,mBAAmB;GACnB,eAAe;GACf,kBAAkB;;GAElB;IACC,+BAA+B;GAChC;;GAEA;IACC,eAAe;IACf,gBAAgB;IAChB,WAAW;GACZ;EACD;;EAEA;GACC,uCAAuC;GACvC,gDAAgD;GAChD,iBAAiB;GACjB,kBAAkB;GAClB,YAAY;GACZ,aAAa;GACb,WAAW;GACX,eAAe;GACf,eAAe;GACf,oBAAoB;GACpB,kBAAkB;GAClB,eAAe;EAChB;EACA;GACC,qCAAqC;GACrC,uBAAuB;GACvB,aAAa;GACb,eAAe;GACf,oBAAoB;GACpB,yBAAyB;GACzB,WAAW;GACX,eAAe;GACf,2CAA2C;GAC3C,iBAAiB;GACjB,kBAAkB;GAClB,kBAAkB;GAClB,eAAe;EAChB;;;;EAIA;GACC,oBAAoB;GACpB,mBAAmB;GACnB,QAAQ;;GAER;IACC,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,qCAAqC;IACrC,gCAAgC;IAChC,eAAe;IACf;KACC,eAAe;KACf,gBAAgB;KAChB,kCAAkC;KAClC,iBAAiB;KACjB,WAAW;IACZ;IACA;KACC,qCAAqC;KACrC,gCAAgC;IACjC;GACD;EACD;CACD;;CAEA;EACC,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;;EAErC;GACC,YAAY;GACZ,aAAa;EACd;CACD;;CAEA;EACC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;;EAER;GACC,uCAAuC;GACvC,YAAY;GACZ,aAAa;GACb,eAAe;GACf,oBAAoB;GACpB,YAAY;GACZ,qCAAqC;GACrC,iBAAiB;GACjB,kBAAkB;GAClB,kBAAkB;GAClB,eAAe;;GAEf;IACC,uCAAuC;IACvC,gCAAgC;GACjC;;GAEA;IACC,uCAAuC;IACvC,gCAAgC;GACjC;;GAEA;IACC,eAAe;IACf,WAAW;GACZ;EACD;CACD;AACD;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,mBAAmB;CACnB,SAAS;CACT,gCAAgC;CAChC,kCAAkC;;CAElC;EACC,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;;EAE3B;GACC,YAAY;GACZ,gBAAgB;GAChB,YAAY;GACZ,aAAa;GACb,8BAA8B;;GAE9B;IACC,aAAa;IACb,cAAc;IACd,UAAU;GACX;EACD;CACD;AACD;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,kBAAkB;CAClB,2CAA2C;CAC3C,2BAA2B;AAC5B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,kBAAkB;CAClB,6BAA6B;CAC7B,aAAa;CACb,2BAA2B;CAC3B,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,aAAa;CACb,WAAW;CACX,iBAAiB;CACjB,uCAAuC;CACvC,gBAAgB;CAChB,sBAAsB;CACtB,kBAAkB;CAClB,2BAA2B;CAC3B,yBAAyB;CACzB,uBAAuB;CACvB,eAAe;CACf,gBAAgB;CAChB,YAAY;CACZ,wCAAwC;CACxC,kBAAkB;AACnB;AACA;CACC,WAAW;AACZ;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,aAAa;CACb,qBAAqB;CACrB,yBAAyB;CACzB,YAAY;CACZ,wBAAwB;CACxB,WAAW;CACX,eAAe;CACf,gCAAgC;CAChC,gCAAgC;CAChC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,UAAU;CACV,MAAM;CACN,gBAAgB;CAChB,uBAAuB;CACvB,gCAAgC;CAChC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,sBAAsB;AACvB;AACA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,UAAU;CACV,MAAM;CACN,gBAAgB;CAChB,uBAAuB;CACvB,gCAAgC;CAChC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,sBAAsB;AACvB;AACA;CACC,aAAa;CACb,iBAAiB;CACjB,mBAAmB;CACnB,2BAA2B;CAC3B,sBAAsB;AACvB;AACA;CACC,gCAAgC;CAChC,gBAAgB;CAChB,eAAe;AAChB;AACA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,6CAA6C;CAC7C,yBAAyB;AAC1B;AACA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,2CAA2C;CAC3C,yBAAyB;AAC1B;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,gCAAgC;CAChC,wBAAwB;CACxB,kBAAkB;AACnB;AACA;CACC,gCAAgC;CAChC,4BAA4B;CAC5B,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,WAAW;CACX,sCAAsC;CACtC,2BAA2B;CAC3B,gBAAgB;CAChB;EACC,WAAW;;EAEX;GACC,gBAAgB;GAChB,iBAAiB;EAClB;;EAEA;GACC,qCAAqC;GACrC,kBAAkB;GAClB,oCAAoC;;GAEpC;IACC,uCAAuC;IACvC,kCAAkC;IAClC,2BAA2B;IAC3B,eAAe;;IAEf;KACC,oCAAoC;KACpC,yCAAyC;KACzC,kCAAkC;IACnC;GACD;EACD;CACD;AACD;AACA;CACC,gBAAgB;CAChB;;EAEC,SAAS;EACT,gBAAgB;EAChB,YAAY;CACb;;CAEA;;EAEC,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;EACjC,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;CAClB;;CAEA;EACC,uCAAuC;EACvC,gCAAgC;EAChC,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,gCAAgC;CACjC;;CAEA;;EAEC,WAAW;CACZ;AACD;AACA;CACC,gBAAgB;CAChB;;EAEC,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;CACb;CACA;EACC,sCAAsC;CACvC;CACA;;EAEC,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;EACjC,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;CAClB;;CAEA;EACC,uCAAuC;EACvC,gCAAgC;EAChC,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,gCAAgC;CACjC;AACD;;AAEA;CACC,gCAAgC;CAChC,oBAAoB;CACpB,sBAAsB;CACtB,QAAQ;CACR,WAAW;CACX,aAAa;;CAEb;EACC,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qCAAqC;EACrC,YAAY;CACb;;CAEA;EACC,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;CAChB;;;AAGD;;AAEA;CACC,gBAAgB;CAChB;;EAEC,qBAAqB;CACtB;;CAEA;EACC,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,yCAAyC;EACzC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;EAChB,gCAAgC;;EAEhC;GACC,oBAAoB;GACpB,sBAAsB;GACtB,kBAAkB;GAClB,mBAAmB;GACnB,2BAA2B;GAC3B,YAAY;GACZ,iBAAiB;GACjB,WAAW;;GAEX;IACC,eAAe;IACf,gBAAgB;GACjB;;GAEA;IACC,eAAe;IACf,oBAAoB;IACpB,sBAAsB;;IAEtB;KACC,cAAc;KACd,oBAAoB;KACpB,sBAAsB;KACtB,mBAAmB;KACnB,QAAQ;;KAER;MACC,oBAAoB;MACpB,mBAAmB;MACnB,QAAQ;;MAER;OACC,cAAc;OACd,eAAe;OACf,kBAAkB;OAClB,uCAAuC;;OAEvC;QACC,qCAAqC;OACtC;MACD;;MAEA;OACC,eAAe;OACf,gBAAgB;MACjB;KACD;;KAEA;MACC,WAAW;MACX,eAAe;MACf,gBAAgB;MAChB,8BAA8B;MAC9B,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,eAAe;MACf;OACC,aAAa;MACd;MACA;OACC,gCAAgC;MACjC;;MAEA;OACC,eAAe;OACf,gBAAgB;MACjB;;MAEA;OACC,YAAY;OACZ,eAAe;OACf,gBAAgB;MACjB;KACD;IACD;GACD;EACD;CACD;CACA;EACC,qCAAqC;CACtC;CACA;EACC,8BAA8B;EAC9B,kBAAkB;EAClB,2CAA2C;CAC5C;AACD;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,4BAA4B;AAC7B;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,2BAA2B;CAC3B,uBAAuB;CACvB;EACC,+BAA+B;CAChC;CACA;EACC;GACC,gBAAgB;GAChB,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;EACxB;CACD;AACD;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,2BAA2B;CAC3B,6CAA6C;CAC7C,yBAAyB;AAC1B;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,2BAA2B;CAC3B,2CAA2C;CAC3C,yBAAyB;AAC1B;AACA;CACC,gBAAgB;CAChB,aAAa;CACb,uBAAuB;CACvB,sBAAsB;CACtB,2BAA2B;CAC3B,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,sBAAsB;CACtB,WAAW;AACZ;AACA;CACC,WAAW;CACX,aAAa;CACb,sCAAsC;AACvC;;;;;AAKA;CACC,SAAO;CACP,kBAAkB;CAClB,aAAa;CACb,iBAAiB;CACjB,6CAA6C;CAC7C,gCAAgC;CAChC,kBAAkB;CAClB,iBAAiB;CACjB,0CAA0C;AAC3C;;;;;AAKA;CACC,SAAO;CACP,iBAAiB;CACjB,aAAa;CACb,yBAAiB;SAAjB,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,sCAAsC;CACtC,0CAA0C;AAC3C;;;;AAIA;CACC,6CAA6C;CAC7C,YAAY;CACZ,kBAAkB;CAClB,gCAAgC;CAChC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;;AAGA;CACC,aAAa;CACb,WAAW;CACX,4BAA4B;CAC5B,YAAY;CACZ,sBAAsB;CACtB,gBAAgB;CAChB,sCAAsC;AACvC;;;AAGA;CACC,aAAa;CACb,YAAY;CACZ,mBAAmB;CACnB,2BAA2B;;CAE3B,qCAAqC;CACrC,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;AACnB;;;AAGA;CACC,6CAA6C;CAC7C,yBAAyB;CACzB,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,8BAA8B;CAC9B,eAAe;CACf;;4BAE2B;CAC3B;EACC,oCAAoC;EACpC,sBAAsB;CACvB;;CAEA;EACC,uCAAuC;EACvC,sBAAsB;CACvB;AACD;;AAEA;CACC,6CAA6C;CAC7C,yBAAyB;CACzB,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,8BAA8B;CAC9B,eAAe;CACf;;4BAE2B;CAC3B;EACC,oCAAoC;EACpC,sBAAsB;CACvB;;CAEA;EACC,uCAAuC;EACvC,sBAAsB;CACvB;AACD;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,gBAAgB;CAChB,kCAAkC;AACnC;;AAEA;CACC,aAAa;CACb,WAAW;CACX,kBAAkB;CAClB,oCAAoC;CACpC,YAAY;AACb;;;AAGA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,2BAA2B;CAC3B,kBAAkB;CAClB,gBAAgB;CAChB,QAAQ;CACR,gBAAgB;AACjB;;;AAGA;CACC,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,QAAQ;CACR,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,mBAAmB;CACnB,2BAA2B;CAC3B,kBAAkB;CAClB;EACC,6CAA6C;EAC7C;GACC,yBAAyB;EAC1B;CACD;AACD;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,YAAY;CACZ,cAAc;CACd,mBAAmB;CACnB,UAAU;AACX;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,2BAA2B;CAC3B,QAAQ;CACR,mBAAmB;AACpB;AACA;CACC,aAAa;CACb,WAAW;CACX,eAAe;CACf,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,yBAAyB;CACzB,sCAAsC;AACvC;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,8BAA8B;CAC9B,YAAY;CACZ,sBAAsB;AACvB;AACA;CACC,2BAA2B;CAC3B,eAAe;CACf,mBAAmB;CACnB,gBAAgB;CAChB,gBAAgB;CAChB,uBAAuB;CACvB,gBAAgB;AACjB;AACA;CACC,kCAAkC;CAClC,eAAe;CACf,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,cAAc;AACf;;AAEA;;CAEC,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,sCAAsC;AACvC;;AAEA;;CAEC,0BAA0B;AAC3B;;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;CACX;EACC,2BAA2B;CAC5B;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,sBAAsB;CACtB,kBAAkB;CAClB,6CAA6C;CAC7C,oCAAoC;AACrC;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,aAAa;CACb,kBAAkB;CAClB,uBAAuB;CACvB,gCAAgC;CAChC,2BAA2B;CAC3B,gBAAgB;CAChB,WAAW;CACX,4CAA4C;AAC7C;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,SAAS;AACV;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,QAAQ;AACT","sourcesContent":[":global(.react-datepicker__input-container) {\n\tinput {\n\t\tbackground: transparent;\n\t}\n}\n\n.header {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 4px;\n\twidth: 100%;\n\tjustify-content: space-between;\n\toverflow-x: visible;\n\tbackground: var(--white-color);\n\tpadding: 10px 10px 10px 70px;\n\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\t.top {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tgap: 6px;\n\n\t\t.buttons {\n\t\t\tdisplay: inline-flex;\n\t\t\talign-items: center;\n\t\t\tgap: 4px;\n\n\t\t\tsvg {\n\t\t\t\twidth: 20px;\n\t\t\t\tmin-width: 20px;\n\t\t\t\tmin-height: 20px;\n\t\t\t}\n\t\t}\n\n\t\t.expand {\n\t\t\twidth: 40px;\n\t\t\theight: 40px;\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tcursor: pointer;\n\t\t\tborder-radius: 4px;\n\n\t\t\t&:hover {\n\t\t\t\tbackground: var(--border-color);\n\t\t\t}\n\n\t\t\tsvg {\n\t\t\t\tmin-width: 25px;\n\t\t\t\tmin-height: 25px;\n\t\t\t\twidth: 25px;\n\t\t\t}\n\t\t}\n\n\t\t.toDay {\n\t\t\tbackground: var(--_16c0982e-background);\n\t\t\tborder: 1px solid var(--border-color) !important;\n\t\t\tpadding: 6px 12px;\n\t\t\tborder-radius: 4px;\n\t\t\tborder: none;\n\t\t\toutline: none;\n\t\t\twidth: 77px;\n\t\t\tmin-width: 77px;\n\t\t\tcursor: pointer;\n\t\t\tfont-family: inherit;\n\t\t\twidth: max-content;\n\t\t\tfont-size: 17px;\n\t\t}\n\t\t.actualToday {\n\t\t\tbackground: var(--_10a37f-background);\n\t\t\tborder: none !important;\n\t\t\toutline: none;\n\t\t\tcursor: pointer;\n\t\t\tfont-family: inherit;\n\t\t\tcolor: var(--white-color);\n\t\t\twidth: 77px;\n\t\t\tmin-width: 77px;\n\t\t\tborder: 1px solid var(--_10a37f-background);\n\t\t\tpadding: 6px 12px;\n\t\t\twidth: max-content;\n\t\t\tborder-radius: 4px;\n\t\t\tfont-size: 17px;\n\t\t}\n\n\n\n\t\t.buttonsNavs {\n\t\t\tdisplay: inline-flex;\n\t\t\talign-items: center;\n\t\t\tgap: 5px;\n\n\t\t\tbutton {\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\twidth: 40px;\n\t\t\t\theight: 40px;\n\t\t\t\tborder-radius: 4px;\n\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t\tbackground: var(--_10a37f-background);\n\t\t\t\tcolor: var(--_16c098-background);\n\t\t\t\tcursor: pointer;\n\t\t\t\tsvg {\n\t\t\t\t\tmin-width: 26px;\n\t\t\t\t\tmin-height: 26px;\n\t\t\t\t\tcolor: var(--_16c0982e-background);\n\t\t\t\t\tfill: transparent;\n\t\t\t\t\twidth: 26px;\n\t\t\t\t}\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: var(--_16c098-background);\n\t\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t[class^='react-datepicker-wrapper'] {\n\t\tdisplay: inline-flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 10px 10px;\n\t\theight: 40px;\n\t\tborder-radius: 4px;\n\t\tborder: 1px solid var(--border-color);\n\n\t\tinput {\n\t\t\twidth: 110px;\n\t\t\toutline: none;\n\t\t}\n\t}\n\n\t.buttonsCalendars {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tgap: 4px;\n\n\t\tbutton {\n\t\t\tbackground: var(--_16c0982e-background);\n\t\t\tborder: none;\n\t\t\toutline: none;\n\t\t\tcursor: pointer;\n\t\t\tfont-family: inherit;\n\t\t\theight: 40px;\n\t\t\tborder: 1px solid var(--border-color);\n\t\t\tpadding: 6px 12px;\n\t\t\twidth: max-content;\n\t\t\tborder-radius: 4px;\n\t\t\tfont-size: 17px;\n\n\t\t\t&.active {\n\t\t\t\tborder-color: var(--_10a37f-background);\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tborder-color: var(--_16c098-background);\n\t\t\t\tcolor: var(--_16c098-background);\n\t\t\t}\n\n\t\t\tsvg {\n\t\t\t\tmin-width: 22px;\n\t\t\t\twidth: 22px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.container {\n\tposition: fixed;\n\twidth: 100vw;\n\theight: calc(100vh);\n\tleft: 0px;\n\tbackground: var(--f5-background);\n\tcolor: var(--text-color-secondary);\n\n\t.app {\n\t\tpadding-left: 70px;\n\t\tbackground: var(--white-color);\n\t\tposition: relative;\n\t\tz-index: 5000;\n\t\tdisplay: flex;\n\t\talign-items: flex-start;\n\t\tgap: 2px;\n\t\theight: calc(100vh - 105px);\n\n\t\t.menu {\n\t\t\theight: 100%;\n\t\t\tmin-width: 240px;\n\t\t\twidth: 240px;\n\t\t\tpadding: 16px;\n\t\t\tbackground: var(--white-color);\n\n\t\t\t&.expand {\n\t\t\t\tdisplay: none;\n\t\t\t\tmin-width: 0px;\n\t\t\t\twidth: 0px;\n\t\t\t}\n\t\t}\n\t}\n}\n.firstTh {\n\tborder-bottom: none !important;\n}\n.hourZoneWrapper {\n\tposition: relative;\n\tbackground: var(--f5-background) !important;\n\tborder-top: none !important;\n}\n.weekHourContent {\n\tposition: relative !important;\n}\n.hourContent {\n\tpadding-left: 10px;\n\tposition: relative !important;\n\tdisplay: flex;\n\tborder-top: none !important;\n\tflex-direction: row;\n}\n.eventPopup {\n\tposition: absolute;\n\ttop: 97px;\n\tborder-radius: 8px;\n\tz-index: 700000;\n}\n.selectedHourContent {\n\tdisplay: flex;\n\twidth: 100%;\n\tmargin-right: 2px;\n\tbackground: var(--_16c0982e-background);\n\tpadding: 2px 5px;\n\tflex-direction: column;\n\tborder-radius: 4px;\n\tjustify-content: flex-start;\n\tcolor: var(--white-color);\n\talign-items: flex-start;\n\tfont-size: 12px;\n\tfont-weight: 500;\n\theight: 100%;\n\tbox-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n\tposition: relative;\n}\n.monthTr {\n\twidth: 100%;\n}\n.monthTd {\n\tposition: relative;\n}\n.hourZoneInner {\n\tposition: absolute;\n\tdisplay: flex;\n\talign-items: flex-end;\n\tjustify-content: flex-end;\n\tbottom: -1px;\n\twidth: calc(100% - 10px);\n\tright: 10px;\n\tz-index: 100000;\n\tbackground: var(--f5-background);\n\tcolor: var(--_10a37f-background);\n\tpadding: 2px 8px;\n\tfont-size: 11px;\n\tfont-weight: 500;\n}\n.dayMonthContainer {\n\tposition: relative;\n}\n.dayMonthInnerContainerWrapper {\n\tposition: absolute;\n\tpadding-left: 5px;\n\tleft: -1px;\n\ttop: 0;\n\tpadding-top: 5px;\n\twidth: calc(100% + 1px);\n\tbackground: var(--f5-background);\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n}\n.dayMonthInnerContainerWrapperWeek {\n\tposition: absolute;\n\tpadding-left: 5px;\n\tleft: -1px;\n\ttop: 0;\n\tpadding-top: 5px;\n\twidth: calc(100% + 1px);\n\tbackground: var(--f5-background);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n}\n.dayMonthInnerContainer {\n\tdisplay: flex;\n\tpadding-left: 5px;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n}\n.dayText {\n\tcolor: var(--_16c098-background);\n\tfont-weight: 500;\n\tfont-size: 12px;\n}\n.dayCircle {\n\twidth: 45px;\n\theight: 45px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 8px;\n\tfont-size: 26px;\n\tpadding-right: 1px;\n\tfont-weight: 500;\n\tbackground-color: var(--_16c09821-background);\n\tcolor: var(--white-color);\n}\n.selectedDayCircle {\n\twidth: 45px;\n\theight: 45px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 8px;\n\tfont-size: 26px;\n\tpadding-right: 1px;\n\tfont-weight: 500;\n\tbackground-color: var(--_10a37f-background);\n\tcolor: var(--white-color);\n}\n.hourContainer {\n\tposition: absolute;\n\ttop: -9px;\n\tright: 10px;\n\tbackground: var(--f5-background);\n\twidth: calc(100% - 10px);\n\tpadding-right: 5px;\n}\n.belowGMTTd {\n\tbackground: var(--f5-background);\n\tborder-left: none !important;\n\tmax-width: 70px !important;\n}\n\n.tableCalendar {\n\tborder-radius: 8px;\n\tz-index: 5000;\n\twidth: 100%;\n\tbackground-color: var(--f5-background);\n\theight: calc(100vh - 112px);\n\toverflow: scroll;\n\ttable {\n\t\twidth: 100%;\n\n\t\tth {\n\t\t\ttext-align: left;\n\t\t\tmin-height: 100px;\n\t\t}\n\n\t\ttd {\n\t\t\tborder: 1px solid var(--border-color);\n\t\t\ttext-align: center;\n\t\t\tbackground-color: var(--white-color);\n\n\t\t\t&.active {\n\t\t\t\tbackground: var(--_16c09821-background);\n\t\t\t\tborder-color: var(--_16c098-color);\n\t\t\t\tcolor: var(--_16c098-color);\n\t\t\t\tcursor: pointer;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: var(--e6fff9-background);\n\t\t\t\t\tborder-color: var(--_16c09821-background);\n\t\t\t\t\tcolor: var(--_16c09821-background);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.calendarDay {\n\tmin-width: 750px;\n\tth,\n\ttd {\n\t\twidth: 7%;\n\t\tmin-height: 40px;\n\t\theight: 40px;\n\t}\n\n\tth:nth-child(1),\n\ttd:nth-child(1) {\n\t\tposition: relative;\n\t\tmin-width: 70px;\n\t\twidth: 70px;\n\t\tbackground: var(--f5-background);\n\t\tcolor: var(--_10a37f-background);\n\t\tborder-color: var(--border-color);\n\t\tborder-left: none !important;\n\t\tborder-right: none !important;\n\t\tpadding: 2px 5px;\n\t\tfont-size: 11px;\n\t\tfont-weight: 500;\n\t\ttext-align: right;\n\t}\n\n\tth {\n\t\tbackground: var(--_16c0982e-background);\n\t\tcolor: var(--_10a37f-background);\n\t\tborder-color: var(--_16c0982e-background);\n\t\tpadding: 2px 9px;\n\t\tfont-size: 15px;\n\t\tfont-weight: 600;\n\t}\n\n\tth:nth-child(1) {\n\t\tbackground: var(--f5-background);\n\t}\n\n\tth:nth-child(2),\n\ttd:nth-child(2) {\n\t\twidth: 100%;\n\t}\n}\n.calendarWeek {\n\tmin-width: 750px;\n\tth,\n\ttd {\n\t\twidth: 11vw !important;\n\t\tmin-height: 40px;\n\t\theight: 40px;\n\t}\n\ttbody {\n\t\tbackground-color: var(--f5-background);\n\t}\n\tth:nth-child(1),\n\ttd:nth-child(1) {\n\t\tposition: relative;\n\t\tmin-width: 70px;\n\t\twidth: 70px !important;\n\t\tbackground: var(--f5-background);\n\t\tcolor: var(--_10a37f-background);\n\t\tborder-color: var(--border-color);\n\t\tborder-left: none !important;\n\t\tborder-right: none !important;\n\t\tpadding: 2px 5px;\n\t\tfont-size: 11px;\n\t\tfont-weight: 500;\n\t\ttext-align: right;\n\t}\n\n\tth {\n\t\tbackground: var(--_16c0982e-background);\n\t\tcolor: var(--_10a37f-background);\n\t\tborder-color: var(--_16c0982e-background);\n\t\tpadding: 2px 9px;\n\t\tfont-size: 15px;\n\t\tfont-weight: 600;\n\t}\n\n\tth:nth-child(1) {\n\t\tbackground: var(--f5-background);\n\t}\n}\n\n.events {\n\tbackground: var(--f5-background);\n\tdisplay: inline-flex;\n\tflex-direction: column;\n\tgap: 2px;\n\twidth: 100%;\n\tpadding: 10px;\n\n\t.item {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 2px;\n\t\tborder: 1px solid var(--border-color);\n\t\tpadding: 6px;\n\t}\n\n\tstrong {\n\t\tfont-size: 10px;\n\t\ttext-transform: uppercase;\n\t\tline-height: 2px;\n\t\tmargin-top: 7px;\n\t}\n\n\n}\n\n.calendarMonth {\n\tmin-width: 750px;\n\tth,\n\ttd {\n\t\twidth: calc(100% / 7);\n\t}\n\n\tth {\n\t\ttext-align: center;\n\t\tborder-bottom: none;\n\t\tcolor: var(--_10a37f-background);\n\t\tborder-color: var(--_16c0982e-background);\n\t\tfont-size: 11px;\n\t\tpadding-top: 2px;\n\t}\n\n\ttd {\n\t\tborder-top: none;\n\t\theight: calc((100vh / 5) - 26px);\n\n\t\t.day {\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tposition: relative;\n\t\t\talign-items: center;\n\t\t\tjustify-content: flex-start;\n\t\t\theight: 100%;\n\t\t\tmax-height: 175px;\n\t\t\twidth: 100%;\n\n\t\t\tb {\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 800;\n\t\t\t}\n\n\t\t\tul {\n\t\t\t\tmargin-top: 4px;\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tflex-direction: column;\n\n\t\t\t\tli {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 4px;\n\n\t\t\t\t\t.date {\n\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tgap: 4px;\n\n\t\t\t\t\t\t.dot {\n\t\t\t\t\t\t\tmin-width: 8px;\n\t\t\t\t\t\t\tmin-height: 8px;\n\t\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\t\tbackground: var(--_16c0982e-background);\n\n\t\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t\tbackground: var(--_10a37f-background);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\tspan {\n\t\t\t\t\t\t\tfont-size: 11px;\n\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.info {\n\t\t\t\t\t\twidth: 80px;\n\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\tbackground: var(--white-color);\n\t\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\t\tpadding: 2px 4px;\n\t\t\t\t\t\ttext-wrap: nowrap;\n\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t&::-webkit-scrollbar {\n\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tbackground: var(--f5-background);\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\tspan {\n\t\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\tb {\n\t\t\t\t\t\t\twidth: 100px;\n\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\tthead tr {\n\t\tborder: 1px solid var(--border-color);\n\t}\n\tthead tr th {\n\t\tbackground: var(--white-color);\n\t\ttext-align: center;\n\t\tborder-right: 1px solid var(--border-color);\n\t}\n}\n.notScrollableTableCalendar {\n\toverflow: hidden !important;\n}\n.calendarDayHeader {\n\tmin-height: 100px !important;\n}\n\n.monthDayLi {\n\tpadding: 3px;\n\tborder-radius: 2px;\n\tdisplay: flex;\n\twidth: 100%;\n\tmax-width: 150px;\n\tposition: relative;\n\tcursor: pointer;\n\tuser-select: none;\n\tjustify-content: flex-start;\n\talign-items: flex-start;\n\t&:hover {\n\t\tbackground: var(--border-color);\n\t}\n\tdiv {\n\t\tspan {\n\t\t\tmax-width: 130px;\n\t\t\twhite-space: nowrap;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\t}\n}\n.monthDayContainer {\n\tmargin: 2px;\n\tborder-radius: 50%;\n\tfont-size: 10px;\n\twidth: 25px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 25px;\n\tfont-weight: 400 !important;\n\tbackground-color: var(--_16c09821-background);\n\tcolor: var(--white-color);\n}\n.selectedMonthDayContainer {\n\tmargin: 2px;\n\tborder-radius: 50%;\n\tfont-size: 10px;\n\twidth: 25px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 25px;\n\tfont-weight: 400 !important;\n\tbackground-color: var(--_10a37f-background);\n\tcolor: var(--white-color);\n}\n.scheduleWrapper {\n\tmin-width: 750px;\n\tdisplay: flex;\n\talign-items: flex-start;\n\tflex-direction: column;\n\tjustify-content: flex-start;\n\twidth: 100%;\n}\n\n.scheduleEventsContainer {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n\twidth: 100%;\n}\n.calendarContainer {\n\twidth: 100%;\n\tpadding: 20px;\n\tbackground-color: var(--f5-background);\n}\n\n\n\n\n.dayHeader {\n\tflex: 1;\n\ttext-align: center;\n\tpadding: 10px;\n\tfont-weight: bold;\n\tbackground-color: var(--_16c0982e-background);\n\tcolor: var(--_10a37f-background);\n\tborder-radius: 5px;\n\tmargin-right: 2px;\n\tbox-shadow: 2px 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n\n\n\n.dayCell {\n\tflex: 1;\n\tmin-height: 100px;\n\tpadding: 10px;\n\tuser-select: none;\n\tmargin-right: 2px;\n\tborder-radius: 4px;\n\tposition: relative;\n\tbackground-color: var(--_16c098-color);\n\tbox-shadow: 2px 3px 5px rgba(0, 0, 0, 0.2);\n}\n\n\n\n.eventText {\n\tbackground-color: var(--_16c09821-background);\n\tpadding: 5px;\n\tborder-radius: 5px;\n\tcolor: var(--_10a37f-background);\n\tfont-size: 12px;\n\ttext-align: center;\n}\n\n.calendarMonthWrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n}\n\n\n.timeline {\n\tdisplay: flex;\n\twidth: 100%;\n\tpadding: 10px 20px 10px 70px;\n\theight: 100%;\n\tflex-direction: column;\n\tmin-width: 990px;\n\tbackground-color: var(--f5-background);\n}\n\n\n.dayContainer {\n\tdisplay: flex;\n\theight: 35px;\n\talign-items: center;\n\tjustify-content: flex-start;\n\n\tborder: 1px solid var(--border-color);\n\tborder-radius: 4px;\n\tmargin-bottom: 15px;\n\tposition: relative;\n}\n\n\n.navArrow {\n\tbackground-color: var(--_16c09821-background);\n\tcolor: var(--white-color);\n\tborder: none;\n\theight: 100%;\n\tfont-size: 11px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 30px;\n\tborder-radius: 3px 0px 0px 3px;\n\tcursor: pointer;\n\ttransition:\n\t\tbackground 0.2s ease-in-out,\n\t\ttransform 0.1s ease-in-out;\n\t&:hover {\n\t\tbackground: var(--e6fff9-background);\n\t\ttransform: scale(1.05);\n\t}\n\n\t&:active {\n\t\tbackground: var(--_16c09821-background);\n\t\ttransform: scale(0.95);\n\t}\n}\n\n.navArrowRight {\n\tbackground-color: var(--_16c09821-background);\n\tcolor: var(--white-color);\n\tborder: none;\n\theight: 100%;\n\tfont-size: 11px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 30px;\n\tborder-radius: 0px 3px 3px 0px;\n\tcursor: pointer;\n\ttransition:\n\t\tbackground 0.2s ease-in-out,\n\t\ttransform 0.1s ease-in-out;\n\t&:hover {\n\t\tbackground: var(--e6fff9-background);\n\t\ttransform: scale(1.05);\n\t}\n\n\t&:active {\n\t\tbackground: var(--_16c09821-background);\n\t\ttransform: scale(0.95);\n\t}\n}\n\n.timelineDays {\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n}\n\n.timelineDay {\n\ttext-align: start;\n\tpadding: 0px 5px;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tcolor: var(--_16c09821-background);\n}\n\n.eventsContainer {\n\tdisplay: flex;\n\twidth: 100%;\n\tposition: relative;\n\tbackground-color: var(--white-color);\n\theight: 100%;\n}\n\n\n.eventsForDay {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tposition: relative;\n\toverflow-x: show;\n\tgap: 3px;\n\toverflow-y: auto;\n}\n\n\n.timelineEventCard {\n\tdisplay: flex;\n\tflex-direction: row;\n\twidth: 100%;\n\tgap: 3px;\n\theight: 50px;\n\tmin-height: 50px;\n\tpadding: 0px 5px;\n\talign-items: center;\n\tcursor: pointer;\n\tuser-select: none;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tborder-radius: 3px;\n\t&:hover {\n\t\tbackground-color: var(--_16c0982e-background);\n\t\t.eventDesc {\n\t\t\tcolor: var(--white-color);\n\t\t}\n\t}\n}\n.eventColorDiv {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\theight: 37px;\n\tmin-width: 8px;\n\tborder-radius: 15px;\n\twidth: 8px;\n}\n.eventRightContainer {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\tjustify-content: flex-start;\n\tgap: 3px;\n\tflex-direction: row;\n}\n.eventUserImage {\n\tdisplay: flex;\n\twidth: 27px;\n\tmax-width: 27px;\n\tmin-width: 27px;\n\theight: 27px;\n\tmax-height: 27px;\n\tmin-height: 27px;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 15px;\n\tfont-weight: bold;\n\tborder-radius: 50px;\n\tcolor: var(--white-color);\n\tbackground-color: var(--_16c098-color);\n}\n.eventData {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: space-between;\n\theight: 100%;\n\tflex-direction: column;\n}\n.eventTitle {\n\tcolor: var(--_3c3a3a-color);\n\tfont-size: 13px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\tfont-weight: 600;\n\ttext-overflow: ellipsis;\n\tline-height: 1.2;\n}\n.eventDesc {\n\tcolor: var(--text-color-secondary);\n\tfont-size: 11px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tline-height: 1;\n}\n\n.eventTitle,\n.eventDesc {\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\ttransition: max-width 0.3s ease-in-out;\n}\n\n.timelineEventCard:hover .eventTitle,\n.timelineEventCard:hover .eventDesc {\n\tmax-width: none !important; \n}\n\n.showMoreButton {\n\tcolor: var(--_16c0982e-background);\n\tcursor: pointer;\n\tfont-size: 12px;\n\tmargin-left: -2px;\n\tfont-weight: 600;\n\ttext-align: center;\n\twidth: 100%;\n\t&:hover {\n\t\tcolor: var(--_16c098-color);\n\t}\n}\n\n.hoursWrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\tflex-direction: column;\n\tborder-radius: 5px;\n\tborder: 1px solid var(--_16c0982e-background);\n\tbackground-color: var(--white-color);\n}\n\n.hourItem {\n\tfont-size: 11px;\n\tposition: relative;\n\tdisplay: flex;\n\tmargin-left: -22px;\n\talign-items: flex-start;\n\tcolor: var(--_10a37f-background);\n\tjustify-content: flex-start;\n\tfont-weight: 500;\n\twidth: 100%;\n\tborder-bottom: 1px solid var(--border-color);\n}\n.hourText {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tposition: absolute;\n\theight: 100%;\n\tleft: -50px;\n\ttop: -8px;\n}\n\n.eventListContainer {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tgap: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_aR2Gy`,
	"top": `top_E1vxr`,
	"buttons": `buttons_NEm4D`,
	"expand": `expand_POsJO`,
	"toDay": `toDay_YD4Zb`,
	"actualToday": `actualToday_iZnpY`,
	"buttonsNavs": `buttonsNavs_CbHXL`,
	"buttonsCalendars": `buttonsCalendars_k2ItT`,
	"active": `active_Hrvyf`,
	"container": `container_ozqP_`,
	"app": `app_hsNVI`,
	"menu": `menu_WYe8x`,
	"firstTh": `firstTh_vyCaw`,
	"hourZoneWrapper": `hourZoneWrapper_HhhGb`,
	"weekHourContent": `weekHourContent_DtKgu`,
	"hourContent": `hourContent_K6fvJ`,
	"eventPopup": `eventPopup_FIFiO`,
	"selectedHourContent": `selectedHourContent_Rp_zp`,
	"monthTr": `monthTr_JY25K`,
	"monthTd": `monthTd_JpEoz`,
	"hourZoneInner": `hourZoneInner_ilaiX`,
	"dayMonthContainer": `dayMonthContainer_tunKk`,
	"dayMonthInnerContainerWrapper": `dayMonthInnerContainerWrapper_e3YH4`,
	"dayMonthInnerContainerWrapperWeek": `dayMonthInnerContainerWrapperWeek_u0JjC`,
	"dayMonthInnerContainer": `dayMonthInnerContainer_anzRz`,
	"dayText": `dayText_yyjed`,
	"dayCircle": `dayCircle_FP45k`,
	"selectedDayCircle": `selectedDayCircle_UZVGR`,
	"hourContainer": `hourContainer_CgGrr`,
	"belowGMTTd": `belowGMTTd_A9_Do`,
	"tableCalendar": `tableCalendar_OMmQQ`,
	"calendarDay": `calendarDay_xojCH`,
	"calendarWeek": `calendarWeek_AdmTw`,
	"events": `events_Zye9X`,
	"item": `item_x8H4v`,
	"calendarMonth": `calendarMonth_ZuSkR`,
	"day": `day_MdvaO`,
	"date": `date_Hji3n`,
	"dot": `dot_TtuBQ`,
	"info": `info_PkleC`,
	"notScrollableTableCalendar": `notScrollableTableCalendar_MVJI0`,
	"calendarDayHeader": `calendarDayHeader_FnAub`,
	"monthDayLi": `monthDayLi_PrdJ4`,
	"monthDayContainer": `monthDayContainer_ZhOgI`,
	"selectedMonthDayContainer": `selectedMonthDayContainer_N5Xqg`,
	"scheduleWrapper": `scheduleWrapper_H_CpN`,
	"scheduleEventsContainer": `scheduleEventsContainer_cidOt`,
	"calendarContainer": `calendarContainer_ayZKL`,
	"dayHeader": `dayHeader_wzd5d`,
	"dayCell": `dayCell_QuY4q`,
	"eventText": `eventText_W4huq`,
	"calendarMonthWrapper": `calendarMonthWrapper_ij94I`,
	"timeline": `timeline_y22OX`,
	"dayContainer": `dayContainer_SYnP0`,
	"navArrow": `navArrow_uicrM`,
	"navArrowRight": `navArrowRight_jq2Ub`,
	"timelineDays": `timelineDays_pPL6q`,
	"timelineDay": `timelineDay_lEWhH`,
	"eventsContainer": `eventsContainer_owEfo`,
	"eventsForDay": `eventsForDay_Qa51T`,
	"timelineEventCard": `timelineEventCard_QLqcG`,
	"eventDesc": `eventDesc_X3itk`,
	"eventColorDiv": `eventColorDiv_emoMh`,
	"eventRightContainer": `eventRightContainer_Xah68`,
	"eventUserImage": `eventUserImage_n_6GZ`,
	"eventData": `eventData_ty9NC`,
	"eventTitle": `eventTitle_aNYm4`,
	"showMoreButton": `showMoreButton_Y7Bnl`,
	"hoursWrapper": `hoursWrapper_yX3VG`,
	"hourItem": `hourItem_kdVHQ`,
	"hourText": `hourText_QJM5_`,
	"eventListContainer": `eventListContainer_WlTaS`
};
export default ___CSS_LOADER_EXPORT___;
